import FETCH from "../utils/fetch";
import ROUTES from "../config/routes";

const fetchAllBudget = async (startDate, endDate, category,divorceBudget) => {
  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));
  const ID = localStorage.getItem("accessId");
   let queryParams = `startDate=${startDate}&endDate=${endDate}&category=${category}`;
  
  if (divorceBudget !== undefined && divorceBudget !== null && divorceBudget !== "") {
    queryParams += `&divorceBudget=${divorceBudget}`;
  }

  if (userRole === "Financial Advisor Client") {
    queryParams += `&clientId=${ID}`;
  }

  let res = await FETCH.get({
    url: `${ROUTES.GET_ALL_BUDGETS}?${queryParams}`,
  });
  return res;
};
const fetchAllTransactionCatgoires = async () => {
  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));
  const ID = localStorage.getItem("accessId");
  let res = await FETCH.get({
    url:
      userRole === "Financial Advisor Client"
        ? `${ROUTES.GET_ALL_TRANSACTION_CATEGORIES}?clientId=${ID}`
        : `${ROUTES.GET_ALL_TRANSACTION_CATEGORIES}`,
  });
  return res;
};

const fetchAllTransactionSubCatgoires = async () => {
  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));
  const ID = localStorage.getItem("accessId");
  let res = await FETCH.get({
    url:
      userRole === "Financial Advisor Client"
        ? `${ROUTES.GET_ALL_TRANSACTION_SUB_CATEGORIES}?clientId=${ID}`
        : `${ROUTES.GET_ALL_TRANSACTION_SUB_CATEGORIES}`,
  });
  return res;
};

const updateAllTransactionCategoires = async (body) => {
  let res = await FETCH.put2({
    url: `${ROUTES.GET_ALL_TRANSACTION_CATEGORIES}`,
    body,
  });
  return res;
};

const updateAllTransactionSubCategoires = async (body) => {
  let res = await FETCH.put2({
    url: `${ROUTES.GET_ALL_TRANSACTION_SUB_CATEGORIES}`,
    body,
  });
  return res;
};
const fetchAllTransaction = async (page, limit) => {
  const userRole =
    localStorage.getItem("role") !== "undefined" &&
    JSON.parse(localStorage.getItem("role"));
  const ID = localStorage.getItem("accessId");
  let queryParams = `page=${page}&limit=${limit}`;

  if (userRole === "Financial Advisor Client" && ID) {
    queryParams += `&clientId=${ID}`;
  }

  let res = await FETCH.get({
    url: `${ROUTES.GET_ALL_TRANSACTIONS}?${queryParams}`,
  });
  return res;
};
const getCalculatedBudgetTransactions = async (body) => {
  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));
  const ID = localStorage.getItem("accessId");
  let res = await FETCH.post({
    url:
      userRole === "Financial Advisor Client"
        ? `${ROUTES.CALCULATED_BUDGET_TRANSACTIONS}?clientId=${ID}`
        : `${ROUTES.CALCULATED_BUDGET_TRANSACTIONS}`,
    body,
  });
  return res;
};
const addRecurringToken = async (body) => {
   const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));
  const ID = localStorage.getItem("accessId");
  let res = await FETCH.post({
    url:  userRole === "Financial Advisor Client"
        ? `${ROUTES.RECURRING_TOKEN}?clientId=${ID}`
        : `${ROUTES.RECURRING_TOKEN}`,
    body,
  });
  return res;
};
const fetchRecurringToken = async (page, token) => {
   const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));
  const ID = localStorage.getItem("accessId");
  let url = userRole === "Financial Advisor Client"
        ? `${ROUTES.RECURRING_TOKEN}?page=${page}&limit=10&clientId=${ID}`
        : `${ROUTES.RECURRING_TOKEN}?page=${page}&limit=10`;
  
  if (token) {
    url += `&token=${token}`;
  }

  let res = await FETCH.get({
    url: url,
  });
  return res;
};
const updateRecurringToken = async (body) => {
   const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));
  const ID = localStorage.getItem("accessId");
  let res = await FETCH.put2({
    url: userRole === "Financial Advisor Client"
        ? `${ROUTES.RECURRING_TOKEN}?clientId=${ID}`
        : `${ROUTES.RECURRING_TOKEN}`,
    body,
  });
  return res;
};
const updateRecurringTokenPattren = async (body) => {
  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));
  const ID = localStorage.getItem("accessId");
  let res = await FETCH.put2({
    url: userRole === "Financial Advisor Client"
        ? `${ROUTES.RECURRING_TOKEN_UPDATE}?clientId=${ID}`
        : `${ROUTES.RECURRING_TOKEN_UPDATE}`,
    body,
  });
  return res;
};
const fetchSystemRecurringTransactions = async (page) => {
  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));
  const ID = localStorage.getItem("accessId");
  let res = await FETCH.get({
    url:
      userRole === "Financial Advisor Client"
        ? `${ROUTES.SYSTEM_RECURRING_TRANSACTIONS}?page=${page}&limit=10&clientId=${ID}`
        : `${ROUTES.SYSTEM_RECURRING_TRANSACTIONS}?page=${page}&limit=10`,
  });
  return res;
};
const updateMonthlyBudget = async (body) => {
  let res = await FETCH.put2({
    url: `${ROUTES.UPADTE_MONTHLY_BUDGET}`,
    body,
  });
  return res;
};
const fetchFilterTransaction = async (queryParam) => {
  const userRole =
    localStorage.getItem("role") !== "undefined" &&
    JSON.parse(localStorage.getItem("role"));
  const ID = localStorage.getItem("accessId");
  let queryParams = queryParam || "";

  if (userRole === "Financial Advisor Client" && ID) {
    queryParams += `${queryParams ? "&" : ""}clientId=${ID}`;
  }

  let res = await FETCH.get({
    url: `${ROUTES.GET_FILTER_TRANSACTIONS}?${queryParams}`,
  });
  return res;
};
const deleteRecurringToken = async (id) => {
  let res = await FETCH.deletee({
    url: `${ROUTES.RECURRING_TOKEN}`,
    body: id,
  });
  return res;
};
const deleteRecurringTokenPattern = async (id) => {
  let res = await FETCH.deletee({
    url: `${ROUTES.RECURRING_TOKEN_UPDATE}`,
    body: id,
  });
  return res;
};
const addRecurringTokenPattren = async (body) => {
  let res = await FETCH.post({
    url: `${ROUTES.RECURRING_TOKEN_UPDATE}`,
    body,
  });
  return res;
};

const addTransactionRule = async (body) => {
  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));
  const ID = localStorage.getItem("accessId");
  let res = await FETCH.post({
    url: userRole === "Financial Advisor Client"
        ? `${ROUTES.TRANSACTIONS_RULE}?clientId=${ID}`
        : `${ROUTES.TRANSACTIONS_RULE}`,
    body,
  });
  return res;
};
const updateTransactionRule = async (body) => {
  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));
  const ID = localStorage.getItem("accessId");
  let res = await FETCH.put2({
    url: userRole === "Financial Advisor Client"
        ? `${ROUTES.TRANSACTIONS_RULE}?clientId=${ID}`
        : `${ROUTES.TRANSACTIONS_RULE}`,
    body,
  });
  return res;
};
const deleteTransactionRule = async (id) => {
  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));
  const ID = localStorage.getItem("accessId");
  let res = await FETCH.deletee({
    url: userRole === "Financial Advisor Client"
        ? `${ROUTES.TRANSACTIONS_RULE}?id=${id}&clientId=${ID}`
        : `${ROUTES.TRANSACTIONS_RULE}?id=${id}`,
    body: id,
  });
  return res;
};
const fetchTransactionsRules = async (page, ruleName) => {
  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));
  const ID = localStorage.getItem("accessId");
  let url = userRole === "Financial Advisor Client"
    ? `${ROUTES.TRANSACTIONS_RULE}?page=${page}&limit=10&clientId=${ID}`
    : `${ROUTES.TRANSACTIONS_RULE}?page=${page}&limit=10`;

  if (ruleName) {
    url += `&ruleName=${ruleName}`;
  }

  let res = await FETCH.get({
    url: url,
  });
  return res;
};
const updatePreviousTransactionsForRecurring = async (tokenId, patternId) => {
  let res = await FETCH.post({
    url: patternId
      ? `${ROUTES.PAST_RECURRING}?tokenId=${tokenId}&patternId=${patternId}`
      : `${ROUTES.PAST_RECURRING}?tokenId=${tokenId}`,
    body: {},
  });
  return res;
};
const fetchAllRuleBasedTransaction = async (ruleId) => {
  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));
  const ID = localStorage.getItem("accessId");
  let res = await FETCH.get({
    url: userRole === "Financial Advisor Client"
        ? `${ROUTES.RULE_TRANSACTIONS}?ruleId=${ruleId}&clientId=${ID}`
        : `${ROUTES.RULE_TRANSACTIONS}?ruleId=${ruleId}`,
  });
  return res;
};
const updateRuleBasedTransactions = async (body) => {
  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));
  const ID = localStorage.getItem("accessId");
  let res = await FETCH.put2({
    url: userRole === "Financial Advisor Client"
        ? `${ROUTES.RULE_TRANSACTIONS}?clientId=${ID}`
        : `${ROUTES.RULE_TRANSACTIONS}`,
    body,
  });
  return res;
};
const fetchRecurringAppliedTransaction = async (categoryId, page, limit) => {
  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));
  const ID = localStorage.getItem("accessId");
  let res = await FETCH.get({
    url: userRole === "Financial Advisor Client"
        ? `${ROUTES.RECURRING_CATEGORY_TRANSACTIONS}?categoryId=${categoryId}&page=${page}&limit=${limit}&clientId=${ID}`
        : `${ROUTES.RECURRING_CATEGORY_TRANSACTIONS}?categoryId=${categoryId}&page=${page}&limit=${limit}`,
  });
  return res;
};
const fetchRecurringPattrenAppliedTransaction = async (
  categoryId,
  patternId,
  page,
  limit
) => {
  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));
  const ID = localStorage.getItem("accessId");
  let res = await FETCH.get({
    url: userRole === "Financial Advisor Client"
        ? `${ROUTES.RECURRING_CATEGORY_TRANSACTIONS}?categoryId=${categoryId}&pattrenId=${patternId}&page=${page}&limit=${limit}&clientId=${ID}`
        : `${ROUTES.RECURRING_CATEGORY_TRANSACTIONS}?categoryId=${categoryId}&pattrenId=${patternId}&page=${page}&limit=${limit}`,
  });
  return res;
};
const searchRecurringAppliedTransaction = async (page, limit, name) => {
  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));
  const ID = localStorage.getItem("accessId");
  let res = await FETCH.get({
    url: userRole === "Financial Advisor Client"
        ? `${ROUTES.SEARCH_RECURRING_CATEGORY_TRANSACTIONS}?page=${page}&limit=${limit}&name=${name}&clientId=${ID}`
        : `${ROUTES.SEARCH_RECURRING_CATEGORY_TRANSACTIONS}?page=${page}&limit=${limit}&name=${name}`,
  });
  return res;
};
const createTransactionsForRecurring = async (body) => {
  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));
  const ID = localStorage.getItem("accessId");
  let res = await FETCH.post({
    url: userRole === "Financial Advisor Client"
        ? `${ROUTES.RECURRING_CATEGORY_TRANSACTIONS_CREATE}?clientId=${ID}`
        : `${ROUTES.RECURRING_CATEGORY_TRANSACTIONS_CREATE}`,
    body,
  });
  return res;
};
const fetchRecurringPrediction = async (page, limit) => {
  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));
  const ID = localStorage.getItem("accessId");
  let res = await FETCH.get({
    url: userRole === "Financial Advisor Client"
        ? `${ROUTES.RECURRING_PREDICTION_TRANSACTIONS}?page=${page}&limit=${
      limit ? limit : 10
    }&clientId=${ID}` 
    : `${ROUTES.RECURRING_PREDICTION_TRANSACTIONS}?page=${page}&limit=${
      limit ? limit : 10
    }`,
  });
  return res;
};
const fetchAllRelatedTransaction = async (id) => {
  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));
  const ID = localStorage.getItem("accessId");
  let res = await FETCH.get({
    url: userRole === "Financial Advisor Client"
        ? `${ROUTES.RECURRING_FOUND_TRANSACTIONS}?recurringId=${id}&clientId=${ID}`
        : `${ROUTES.RECURRING_FOUND_TRANSACTIONS}?recurringId=${id}`,
  });
  return res;
};
const fetchBudgetSummed = async () => {
  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));
  const ID = localStorage.getItem("accessId");
  let res = await FETCH.get({
    url:
      userRole === "Financial Advisor Client"
        ? `${ROUTES.REPORT_BUDGET_SUMMED}?clientId=${ID}`
        : `${ROUTES.REPORT_BUDGET_SUMMED}`,
  });
  return res;
};
const createTransactionsReport = async (body) => {
  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));
  const ID = localStorage.getItem("accessId");
  let res = await FETCH.post({
    url: userRole === "Financial Advisor Client"
        ? `${ROUTES.TRANSACTION_REPORTS}?clientId=${ID}`
        : `${ROUTES.TRANSACTION_REPORTS}`,
    body,
  });
  return res;
};

const fetchPlaidCooldowntime = async () => {
  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));
  const ID = localStorage.getItem("accessId");
  let res = await FETCH.get({
    url: userRole === "Financial Advisor Client"
        ? `${ROUTES.CHECK_PLAID_COOL_DOWN}?clientId=${ID}`
        : `${ROUTES.CHECK_PLAID_COOL_DOWN}`,
  });
  return res;
};

const BUDGET_API = {
  fetchAllBudget,
  fetchAllTransactionCatgoires,
  fetchAllTransactionSubCatgoires,
  updateAllTransactionCategoires,
  updateAllTransactionSubCategoires,
  fetchAllTransaction,
  getCalculatedBudgetTransactions,
  addRecurringToken,
  fetchRecurringToken,
  updateRecurringToken,
  updateRecurringTokenPattren,
  fetchSystemRecurringTransactions,
  updateMonthlyBudget,
  fetchFilterTransaction,
  deleteRecurringToken,
  deleteRecurringTokenPattern,
  addRecurringTokenPattren,
  addTransactionRule,
  updateTransactionRule,
  deleteTransactionRule,
  fetchTransactionsRules,
  updatePreviousTransactionsForRecurring,
  fetchAllRuleBasedTransaction,
  updateRuleBasedTransactions,
  fetchRecurringAppliedTransaction,
  searchRecurringAppliedTransaction,
  createTransactionsForRecurring,
  fetchRecurringPrediction,
  fetchRecurringPattrenAppliedTransaction,
  fetchAllRelatedTransaction,
  fetchBudgetSummed,
  createTransactionsReport,
  fetchPlaidCooldowntime,
};
export default BUDGET_API;
